














import {Component, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';

const style = namespace('style')

@Component({
  name: "ChangeStyle"
})
export default class ChangeStyle extends Vue{
  @style.Mutation('changeContrast') protected changeContrast:any
  @style.Getter('contrast') protected contrast:any


  darkMode(theme:any) {
    const name = theme.name;
    const dark = theme.dark;
    const light = theme.light;
    // set themes
    // console.log(name)
    Object.keys(dark).forEach(i => {
      this.$vuetify.theme.themes.dark[i] = dark[i];
    });
    Object.keys(light).forEach(i => {
      this.$vuetify.theme.themes.light[i] = light[i];
    });
    localStorage.setItem('themes',theme.name)
    // also save theme name to disable selection
    // this.$vuetify.theme.themes.name = name;
  }
  mounted(){
    const tema_dfault=this.themes[0]
    const name_themes = this.themes.map((el)=>el.name)

    // console.log(localStorage.getItem('themes'))

    if(localStorage.getItem('themes') && name_themes.includes(localStorage.getItem('themes'))){
      let tema = this.themes.filter((element)=> element.name === localStorage.getItem('themes'))[0]
      setTimeout(()=>{
        Object.keys(tema.dark).forEach(i => {
          this.$vuetify.theme.themes.dark[i] = tema.dark[i];
        });
        Object.keys(tema.light).forEach(i => {
          this.$vuetify.theme.themes.light[i] = tema.light[i];
        });
      },0)
    }
    else {
      setTimeout(()=>{
        Object.keys(tema_dfault.dark).forEach(i => {
          this.$vuetify.theme.themes.dark[i] = tema_dfault.dark[i];
        });
        Object.keys(tema_dfault.light).forEach(i => {
          this.$vuetify.theme.themes.light[i] = tema_dfault.light[i];
        });
      },0)
      localStorage.setItem('themes',tema_dfault.name)
    }

  }

  public themes:any[]  =  [
    {
      name: "Default",
      color:'grey',
      light: {
        v_text_default:"#0A0A0A",
        v_text_subtitle:"#494949",
        v_icon:"#9A99A2",
        v_hr:"#E6E4EA",
        v_sub_bg:"#F3F2F7",
        v_bg_default:"#FFFFFF",
        v_alert:"#BA3E3E",
        v_alert_sub:"#FA8C8C",
        v_pl:"#D2EFFF",
        v_btn_default:"#2D9CDB",
        v_dop_color:"#27AE60",
        primary: "#3173d4",
        accent: "#ff6b99",
        secondary: "#26ff8c",
        success: "#a5d64c",
        info: "#ff53d0",
        warning: "#ff8e00",
        error: "#ff5252"
      },
      dark: {
        custom:'#970326',
        primary: "#21CFF3",
        accent: "#FF4081",
        secondary: "#21dc79",
        success: "#86af3f",
        info: "#f34fc6",
        warning: "#FB8C00",
        error: "#FF5252"
      }
    },
    {
      name: "Dark",
      color:'black',
      light: {
        v_text_default:"#ffffff",
        v_text_subtitle:"#c7c4c4",
        v_sub_bg:"#4B5064",
        v_bg_default:"#41434D",
        v_icon:"#9A99A2",
        v_hr:"#E6E4EA",
        v_alert:"#BA3E3E",
        v_alert_sub:"#FA8C8C",
        v_pl:"#757f84",
        v_btn_default:"#FFFFFFFF",
        v_dop_color:"#27AE60",
        primary: "#ffa450",
        accent: "#a1e754",
        secondary: "#92de4e",
        success: "#6dff74",
        info: "#7365ff",
        warning: "#2e8ac0",
        error: "#ff5e3c"
      },
      dark: {
        v_text_default:"#faf9f9",
        v_text_subtitle:"#cecaca",
        v_sub_bg:"#F3F2F7",
        v_bg_default:"#090808",
        v_icon:"#9A99A2",
        v_hr:"#E6E4EA",
        v_alert:"#BA3E3E",
        v_alert_sub:"#FA8C8C",
        v_pl:"#D2EFFF",
        v_btn_default:"#2D9CDB",
        v_dop_color:"#27AE60",
        btn_default:'#bb0c2f',
        drawer_bg:'#000000',
        custom:'#96b14a',
        primary: "#E65100",
        accent: "#7CB342",
        secondary: "#689F38",
        success: "#4CAF50",
        info: "#6156d8",
        warning: "#1565C0",
        error: "#FF7043"
      }
    },
    {
      name: "Contrast",
      color:'#59c1bd',
      light: {
        v_text_default:"#f6f2f2",
        v_text_subtitle:"#d9d6d6",
        v_icon:"#9A99A2",
        v_hr:"#E6E4EA",
        v_sub_bg:"#a32859",
        v_bg_default:"#a53b65",
        v_alert:"#BA3E3E",
        v_alert_sub:"#FA8C8C",
        v_pl:"#D2EFFF",
        v_btn_default:"#2D9CDB",
        v_dop_color:"#27AE60",
        custom:'#efebeb',
        primary: "#090909",
        accent: "#4985de",
        secondary: "#92de4e",
        success: "#6dff74",
        info: "#7365ff",
        warning: "#2e8ac0",
        error: "#ff5e3c"
      },
      dark: {
        primary: "#E65100",
        accent: "#7CB342",
        secondary: "#689F38",
        success: "#4CAF50",
        info: "#6156d8",
        warning: "#1565C0",
        error: "#FF7043"
      }
    }
  ]


}
